import React, { FC, useEffect, useState } from "react";
import LandingCallToAction from "@/features/landing/components/CallToAction";
import ctaImage from "../../../src/features/landing/assets/elgRacing.webp";
import { getChallengeBasedOnClient } from "../../../branchAndBrandSpecific/helperFunctions/getChallengeBasedOnClient";
import { clientAtom } from "@/utils/atoms/atomClient";
import { useAtom } from "jotai";

const RacingPartnerPage: FC = (): JSX.Element => {
  const [challengeLink, setChallengeLink] = useState<string>("");
  const [client, setCurrentClient] = useAtom(clientAtom);
  setCurrentClient("ELGIGANTEN");

  // Fetch current active challenge logic
  const fetch = async () => {
    await getChallengeBasedOnClient(client, "ongoing").then((res) => {
      if (res.slug) {
        setChallengeLink(`/challenges/${res.slug}`);
      }
    });
  };

  // Fetch current active challenge on page load
  useEffect(() => {
    if (client) {
      fetch();
    }
  }, [client]);

  return (
    <div className="partner">
      <LandingCallToAction
        title={"F1® 24: Bliv den hurtigste på banen"}
        desc={
          "Er du hurtig nok til at komme på leaderboardet? Prøv en Formel 1 racer i F1® 24 og sæt din bedste omgangstid. Kør på en ikonisk bane, og kæmp for den øverste placering på leaderboardet. Den hurtigste tid vinder mere end bare æren - er du klar til at træde speederen i bund?"
        }
        image={ctaImage}
        link={challengeLink}
        label={challengeLink !== "" ? "Deltag i udfordringen" : ""}
        float="left"
      />
    </div>
  );
};

export default RacingPartnerPage;
